import { render } from "./MembershipBenefit.vue?vue&type=template&id=21d386d8&scoped=true"
import script from "./MembershipBenefit.vue?vue&type=script&lang=js"
export * from "./MembershipBenefit.vue?vue&type=script&lang=js"

import "./MembershipBenefit.vue?vue&type=style&index=0&id=21d386d8&scoped=true&lang=css"

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d386d8"]])

export default __exports__